import * as React from "react";
import { cn } from "../../lib/utils";

/* ────────────────────────────────────────────────────────────────
   1️⃣  cva 로 variant 정의
   ──────────────────────────────────────────────────────────────── */
import { cva, type VariantProps } from "class-variance-authority";

const inputVariants = cva(
    // 기본 스타일 (버튼에서 default 와 비슷하게)
    "flex w-full rounded-md border-[1px] border-input bg-background px-3 py-2 text-sm " +
    "ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium " +
    "placeholder:text-slate-300 focus-visible:outline-none focus-visible:ring-0 " +
    "focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50",
    {
        variants: {
            variant: {
                default: "",
                basic:
                    "h-9 bg-gray-50 border-gray-200 focus-visible:ring-0 " +
                    "focus-visible:border-primary transition-all text-sm",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

/* ────────────────────────────────────────────────────────────────
   3️⃣  Props 정의
   ──────────────────────────────────────────────────────────────── */
export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> { }


/* ────────────────────────────────────────────────────────────────
   4️⃣  컴포넌트 구현
   ──────────────────────────────────────────────────────────────── */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type = "text", variant = "default", ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(inputVariants({ variant }), className)}
                ref={ref}
                {...props}
            />
        );
    }
);

Input.displayName = "Input";

export { Input };